<template>
  <el-dialog
      :visible.sync="visible"
      :title="dialogTitle"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <div class="table-bar" style="justify-content: flex-start;margin-bottom: 0px">
        <div class="bar-item" v-if="$hasPermission('erp:purchase:checkin:batch')">
          <UploadButton url="/erp/purchase/explain/checkin/receipt/old" @success="readFileSuccess"></UploadButton>
        </div>
        <FileLink file-type="front" file-url="/static/template/采购入库导入模板.xlsx" class="bar-item">下载模板</FileLink>
      </div>
      <ImportErrorCard :errorList="errorList"></ImportErrorCard>
      <SweetTable :data="dataForm.detailList" :is-page="false" :height="500"
                  :summaries-column="['amount','count']">
        <el-table-column label="订单编号" prop="orderCode" align="center">
        </el-table-column>
        <el-table-column label="发货方" v-if="$hasPermission('erp:purchase:checkin:batch')" prop="senderName"
                         align="center" :show-overflow-tooltip="true" :formatter="$c.companyNameFormatter">
        </el-table-column>
        <el-table-column
            label="收货方"
            prop="receiverName"
            header-align="center"
            align="center"
        >
        </el-table-column>
        <el-table-column label="发货时间" width="120" prop="operateTime" align="center"
                         v-if="$hasPermission('erp:purchase:checkin:batch')">
        </el-table-column>
        <el-table-column label="货品信息" prop="product.code" align="center">
          <template #default="{row }">
            <ProductRowCard :product="row.product"></ProductRowCard>
          </template>
        </el-table-column>
        <el-table-column
            label="开票日期"
            prop="receiptDate"
            header-align="center"
            align="center"
            width="120"
        >
        </el-table-column>
        <el-table-column
            label="发票号"
            prop="receiptCode"
            header-align="center"
            align="center"
        >
        </el-table-column>
        <el-table-column
            label="开票数量"
            prop="count"
            header-align="center"
            align="center"
            width="120"
        >
        </el-table-column>
        <el-table-column
            label="开票单价"
            header-align="center"
            align="center"
            width="120"
        >
          <template v-slot="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.price'"
                :rules="detailRule.price"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <el-input v-model="scope.row.price" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="金额"
            prop="totalAmount"
            header-align="center"
            align="center"
            width="120"
        >
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button size="mini" @click="visible=false">{{ $t('cancel') }}</el-button>
      <el-button size="mini" type="primary" @click="dataFormSubmitHandle">确认开票</el-button>
    </template>
  </el-dialog>
</template>

<script>
/**
 * 供应商成品发货弹窗
 */
import UploadButton from '@/components/UploadButton.vue'
import debounce from 'lodash/debounce'
import { countValidator, moneyValidator } from '@/utils/validate'
import ProductRowCard from '@/components/ProductRowCard.vue'
import moment from 'moment'
import BigNumber from 'bignumber.js'
import ImportErrorCard from '@/components/ImportErrorCard.vue'
import FileLink from '@/components/FileLink.vue'

export default {
  components: { FileLink, ProductRowCard, UploadButton, ImportErrorCard },
  data () {
    return {
      visible: false,
      dataForm: {},
      errorList: [],
      harbour: '',
      company: { id: '', name: '' },
      receiverType: '',//收货方类型，harbour：港口，factory：工厂
      sendType: ''//发货类型，make：成品/配件发货，purchase：物料发货
    }
  },
  computed: {
    dialogTitle () {
      if (this.sendType === 'purchase') {
        return '采购进项发票导入'
      }
    },
    detailRule () {
      return {
        count: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
          {
            validator: countValidator,
            trigger: 'change',
          },
        ],
        price: [
          {
            required: false,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
          {
            validator: moneyValidator,
            trigger: 'change',
          },
        ],
      }
    },
    dataRule () {
      return {
        sendDate: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'change',
        }]
      }
    }
  },
  methods: {
    readFileSuccess (result) {
      this.errorList = result.errorList
      if (!this.$c.isArrayEmpty(result.dataList)) {
        this.dataForm.detailList = result.dataList
      }
    },
    receiverTypeChanged () {
      this.dataForm.detailList.forEach(row => {
        this.receiverList.forEach(r => {
          delete row[r.id]
        })
      })
      this.receiverList = []
      this.company = { id: '', name: '' }
    },
    factoryChanged (e) {
      this.company = e
      console.log(e)
    },
    add2ReceiverList (data) {
      if (this.receiverList.find(r => r.id === data.id)) {
        return
      }
      this.receiverList.push(data)
    },
    init (detailList) {
      this.errorList = []
      if (this.sendType === 'make') {
        this.company = { id: '', name: '' }
        this.receiverType = 'factory'
        //提取收货方清单
        this.receiverList = []
      }
      if (!this.$c.isArrayEmpty(detailList)) {
        detailList.forEach(row => {
          this.receiverList.forEach(r => {
            row[r.id] = 0
            row.remark = ''
          })
        })
      }

      this.dataForm = {
        sendDate: moment().format('YYYY-MM-DD'),
        remark: '',
        imgs: '',
        detailList: detailList,
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    // 表单提交
    dataFormSubmitHandle:
        debounce(
            function () {
              this.$refs['dataForm'].validate((valid) => {
                if (!valid) {
                  return false
                }
                let postForm = this.$clone(this.dataForm.detailList)
                this.loading = true
                this.$api2
                    .post('/erp/purchase/batch/receipt', postForm)
                    .then(res => {
                      this.loading = false
                      this.$c.success('保存成功').then(() => {
                        this.visible = false
                        this.$emit('change')
                      })
                    })
                    .catch((e) => {
                      this.loading = false
                    })
              })
            },
            1000,
            { leading: true, trailing: false }
        )
  },
}
</script>

